import { SecondTypeCardsBiomarker, ThirdTypeCardBiomarkerDto } from 'api/generated';

export const biomarkersThirdTypeCardValidator = (
  record: Array<ThirdTypeCardBiomarkerDto | SecondTypeCardsBiomarker>,
): string | undefined => {
  if (record?.length < 3) {
    return 'Must be more than 2 biomarkers';
  }
};
